import { render } from "./ProductsLastViewed.vue?vue&type=template&id=3b017f3b"
import script from "./ProductsLastViewed.vue?vue&type=script&lang=js"
export * from "./ProductsLastViewed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__